<div class="row">
  <div class="column--12">
    <!-- Configuration Toggle Button -->
    <div class="config-toggle">
      <button
        mat-flat-button
        extended
        color="primary"
        (click)="toggleSelector()"
        class="text--md"
        [attr.aria-expanded]="showSelector">
        <mat-icon>{{ showSelector ? 'close' : 'settings' }}</mat-icon>
        {{ showSelector ? 'Close Settings' : 'Configure Cards' }}
      </button>
    </div>

    <!-- Collapsible Selector Panel -->
    <div [@slideInOut]="showSelector ? 'in' : 'out'">
      <div class="selector-panel pt--md">
        <mat-card class="selector-card">
          <mat-card-header>
            <mat-card-title>Report Card Preferences</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <div class="quick-actions" *ngIf='displayQuickActions'>
              <button mat-stroked-button (click)="selectAll()" class="action-button">
                <mat-icon>select_all</mat-icon>
                Select All
              </button>
              <button mat-stroked-button (click)="deselectAll()" class="action-button">
                <mat-icon>deselect</mat-icon>
                Deselect All
              </button>
            </div>

            <mat-divider></mat-divider>

            <!-- Card Groups -->
            <div class="card-groups">
              <mat-accordion multi>
                <mat-expansion-panel
                  *ngFor="let group of cardGroups"
                  [expanded]="group.expanded"
                  class="group-panel">

                  <mat-expansion-panel-header>
                    <mat-panel-title class="group-header">
                      <mat-checkbox
                        [checked]="isGroupFullySelected(group)"
                        [indeterminate]="isGroupPartiallySelected(group)"
                        (change)="toggleGroup(group, $event)"
                        (click)="$event.stopPropagation()">
                      </mat-checkbox>
                      <span class="group-label">{{ group.label }}</span>
                      <mat-chip class="card-count">{{ getSelectedCount(group) }}/{{ group.cards.length }}</mat-chip>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="cards-list">
                    <mat-checkbox
                      *ngFor="let card of group.cards"
                      [checked]="selectedCards[card]"
                      (change)="toggleCard(card, $event)"
                      class="card-checkbox">
                      {{ getCardDisplayName(card) }}
                    </mat-checkbox>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-card-content>

          <mat-card-actions align="end">
            <button mat-button (click)="resetToDefaults()">Reset to Defaults</button>
            <button mat-raised-button color="primary" (click)="savePreferences()">
              Save Preferences
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>
</div>
